import { type } from '../constants/manageNumbersConstant'
import { CapabilityListReducer, NumberTypeReducer } from '../models/manageNumbers.interface';

const initialState: CapabilityListReducer = {
    capabilityListLoading: false,
    capabilityListData: {},
    capabilityListError: false,
    capabilityListErrorMsg: '',
}

export const capabilityListReducer = (state: CapabilityListReducer = initialState, action: any): CapabilityListReducer => {

    switch (action.type) {
        case type.CAPABILITY_LIST_LOADING:
            return {
                ...state,
                capabilityListLoading: true,
                capabilityListError: false
            }
        case type.CAPABILITY_LIST_SUCCESS:
            return {
                ...state,
                capabilityListLoading: false,
                capabilityListData: action.payload.res.data,
                capabilityListError: false,
            }
        case type.CAPABILITY_LIST_FAILED:
            return {
                ...state,
                capabilityListLoading: false,
                capabilityListError: true,
                capabilityListErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}

const initialNumberType: NumberTypeReducer = {
    numberTypeLoading: false,
    numberTypeData: {},
    numberTypeError: false,
    numberTypeErrorMsg: '',
}

export const numberTypeReducer = (state: NumberTypeReducer = initialNumberType, action: any): NumberTypeReducer => {

    switch (action.type) {
        case type.NUMBER_TYPE_LOADING:
            return {
                ...state,
                numberTypeLoading: true,
                numberTypeError: false
            }
        case type.NUMBER_TYPE_SUCCESS:
            return {
                ...state,
                numberTypeLoading: false,
                numberTypeData: action.payload.res.data,
                numberTypeError: false,
            }
        case type.NUMBER_TYPE_FAILED:
            return {
                ...state,
                numberTypeLoading: false,
                numberTypeError: true,
                numberTypeErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}
